export const rolesConfig = {
	USER: 1,
	TEAM_MANAGER: 3,
	CLEANER: 6,
	GLOBAL_ADMIN: 101,
	BILLING_ADMIN: 102,
	SITE_ADMIN: 103,
	FLOOR_ADMIN: 104,
	TEAM_ADMIN: [105, 106], // 105: Team Admin, 106: Team Member (!deprecated, ask for this to be able o remove it)
	ASSETS_ADMIN: 107,
	GLOBAL_READ_ONLY: 108,
	SITE_READ_ONLY: 109,
	SITE_LOCK_ADMIN: 110,
	INSTALLER: 111,
	// Access-app roles (App Server registry): no Dashboard capability, still role holders.
	MOBILE_MANAGER: 112,
	APP_GLOBAL_ADMIN: 113,
	APP_SITE_ADMIN: 114,
	OWNER_APP_DIRECT: 115,
	DEVELOPER: 201,
	ASSET_MANAGER: 202,
	INVENTORY_MANAGER: 203
};

// Roles that see every site in the org (no site scoping).
export const ORG_WIDE_ROLES = [
	rolesConfig.GLOBAL_ADMIN,
	rolesConfig.GLOBAL_READ_ONLY,
	rolesConfig.INSTALLER,
	rolesConfig.DEVELOPER
];

// The read-only admin roles (App Server READ_ONLY_ROLE_IDS).
export const READ_ONLY_ROLES = [rolesConfig.GLOBAL_READ_ONLY, rolesConfig.SITE_READ_ONLY];

// True when EVERY role the profile holds is read-only, so the server will refuse its writes
// (RoleMiddleware: a read-only role and no write-admin role). Deliberately the certain case only:
// a mixed profile keeps its controls and the server stays the authority.
export const isReadOnlyProfile = (roles) => {
	const ids = Object.keys(roles ?? {}).map(Number);
	return ids.length > 0 && ids.every((id) => READ_ONLY_ROLES.includes(id));
};

// True when a `selectedProfile.roles` map ({ [roleID]: siteIDs }) holds an org-wide role.
export const hasOrgWideRole = (roles) => Object.keys(roles ?? {}).some((id) => ORG_WIDE_ROLES.includes(Number(id)));

// Admin roles a person can hold, highest first (managePermittedRoles hierarchy).
export const ADMIN_ROLE_ORDER = [
	rolesConfig.GLOBAL_ADMIN,
	rolesConfig.INSTALLER,
	rolesConfig.SITE_ADMIN,
	rolesConfig.GLOBAL_READ_ONLY,
	rolesConfig.SITE_READ_ONLY
];

// Display name of each admin role.
export const ROLE_LABEL = {
	[rolesConfig.GLOBAL_ADMIN]: 'Global Admin',
	[rolesConfig.INSTALLER]: 'Installer',
	[rolesConfig.SITE_ADMIN]: 'Site Admin',
	[rolesConfig.GLOBAL_READ_ONLY]: 'Global Read Only',
	[rolesConfig.SITE_READ_ONLY]: 'Site Read Only'
};

// What each grantable role allows, shown when picking it.
export const ROLE_DESCRIPTION = {
	[rolesConfig.GLOBAL_ADMIN]: 'Full control of every site',
	[rolesConfig.INSTALLER]: 'Sets up and manages the organisation, without billing',
	[rolesConfig.SITE_ADMIN]: 'Full control of one site',
	[rolesConfig.GLOBAL_READ_ONLY]: 'Views every site, cannot make changes',
	[rolesConfig.SITE_READ_ONLY]: 'Views one site, cannot make changes',
	[rolesConfig.DEVELOPER]: 'Platform staff with full control and developer tools'
};
